// Requirements route (/$region/workspace): requirement review (list, source, facts) and the matrix, with the typed search params of spec 4.2 (plus plant types) and the region breadcrumb overridden by the document and clause.
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";

import { WorkspaceScreen } from "@/features/workspace/WorkspaceScreen";
import { workspaceSearchDefaults, workspaceSearchSchema } from "@/features/workspace/search";

export const Route = createFileRoute("/_app/$region/workspace")({
  validateSearch: workspaceSearchSchema,
  search: { middlewares: [stripSearchParams(workspaceSearchDefaults)] },
  staticData: { crumb: "Requirements" },
  component: WorkspaceScreen,
});
